import React from 'react';
import Tippy from '@tippyjs/react';
import { Placement } from 'tippy.js';
import useCurrentWidth from '../../hooks/useCurrentWidth';
import breakpoints from '../../utils/breakpoints';
import 'tippy.js/dist/tippy.css';

import './Tooltip.css';

interface TippyWrapperProps {
  children: React.ReactElement;
  content: string;
  themes?: string;
  placement?: Placement;
}

const TippyWrapper: React.FunctionComponent<TippyWrapperProps> = ({
  children,
  content,
  themes = 'default',
  placement = 'top',
}) => {
  const currentWidth = useCurrentWidth();
  const isMobile = currentWidth <= breakpoints.medium;

  return (
    <Tippy
      arrow
      theme={themes}
      zIndex={999}
      placement={placement}
      animation="fade"
      duration={0}
      trigger={isMobile ? 'click' : 'mouseenter'}
      className="toolTip"
      content={content}
    >
      {children}
    </Tippy>
  );
};

export default TippyWrapper;
